export default __webpack_public_path__ + "90f63e0d49ee037596dc6504c2993344.svg";